import { useQuery } from '@tanstack/react-query';

import CSVService, { type CSVListItem } from '@/services/CSVService';

export const CSV_LIST_QUERY_KEY = ['csv-list'];

export function useCsvList() {
  const { data, isFetching } = useQuery({
    queryKey: CSV_LIST_QUERY_KEY,
    queryFn: () => CSVService.listCsvs(),
  });

  const csvList: CSVListItem[] = data ?? [];

  return {
    csvList,
    isLoading: isFetching,
  };
}
